import { extendTheme, withDefaultColorScheme } from '@chakra-ui/react'
import { colors, semanticTokens } from '@/styles/colors'
import { buttonTheme } from '@/styles/button'
import { fonts } from '@/styles/fonts'
import { tooltipTheme } from '@/styles/tooltip'

const generateSpaces = ({
  from,
  to,
  stepValue,
  initialValue,
  unit = 'rem'
}: {
  from: number
  to: number
  stepValue: number
  initialValue: number
  unit?: string
}) => {
  let currentKey = from
  let currentValue = initialValue
  const res: Record<string, string> = {}

  while (currentKey <= to) {
    res[String(currentKey)] = `${currentValue}${unit}`
    currentValue += stepValue
    currentKey += 1
  }

  return res
}

export const customTheme = extendTheme(
  withDefaultColorScheme({
    colorScheme: 'primary'
  }),
  {
    styles: {
      global: {
        html: {
          h: '100%',
          w: '100%',
          overflow: 'auto'
        },
        body: {
          bg: 'var(--chakra-colors-background-default)',
          h: '100%',
          w: '100%',
          color: 'text.default'
        },
        ul: {
          margin: 0
        }
      }
    },
    colors,
    fonts,
    semanticTokens,
    space: generateSpaces({
      from: 10,
      to: 30,
      initialValue: 2.5,
      stepValue: 0.25
    }),
    lineHeights: {
      double: 1.9
    },
    components: {
      Button: buttonTheme,
      Tooltip: tooltipTheme
    },
    breakpoints: {
      xs: '30em',
      sm: '48em',
      md: '64em',
      lg: '80em',
      xl: '96em'
    },
    shadows: {
      aroundMd: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 -2px 4px -1px rgba(0, 0, 0, 0.06)',
      aroundLg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 -4px 6px -2px rgba(0, 0, 0, 0.05)'
    }
  }
)
